export const capabilitiesList = [
  // editor
  'editor',
  'editor.create',
  'editor.draft',
  'editor.draft.customDeny',
  'editor.planned',
  'editor.published',
  // management
  'management',
  'management.list',
  'management.list.create',
  'management.list.update',
  'management.list.delete',
  'management.list.customDeny',
  // settings
  'settings'
] as const;

export type Capability = (typeof capabilitiesList)[number];
export type Capabilities = Record<Capability, boolean> & {
  // contains any sub-capability
  [K in Capability as `${K}.*`]: boolean;
};
